<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">팝업/배너관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">배너관리</p>
          <ul class="depth">
            <li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
            <li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">배너 조회</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                배너 조회 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목</th>
                  <td colspan="3">{{ bannerInfo.title }}</td>
                </tr>
                <tr>
                  <th scope="row">설명</th>
                  <td colspan="3">
                    <pre><div v-html="bannerInfo.bannerContents"></div></pre>
                  </td>
                </tr>
                <tr>
                  <th scope="row">사용여부</th>
                  <td v-if="bannerInfo.useYn === 'Y'">사용함</td>
                  <td v-else>사용안함</td>
                  <th scope="row">순서</th>
                  <td>{{ bannerInfo.bannerOrder }}</td>
                </tr>
                <tr v-if="bannerInfo.linkUrl != null">
                  <th scope="row">링크주소</th>
                  <td colspan="3">{{ bannerInfo.linkUrl }}</td>
                </tr>
                <tr v-for="(bannerImg, index) in bannerImageInfo" :key="index">
                  <th scope="row">이미지</th>
                  <td colspan="3" @click="downloadAttachFile(bannerImg)">
                    {{ bannerImg.viewNm }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('bannerlist')">목록</button>
          <button class="btn gray" @click="deleteConfirm">삭제</button>
          <button class="btn blue" @click="update">수정</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      bannerId: '',
      bannerInfo: {},
      bannerImageInfo: {},
      menuUrl: '/api/admin/banner',
    };
  },

  mounted() {
    const bannerId = this.$route.query.bannerId;
    if (!bannerId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/bannerlist');
      return;
    }
    this.bannerId = bannerId;

    this.findBanner();
  },

  methods: {
    async findBanner() {
      const res = await axios('get', '/api/admin/banner/view.json', {
        bannerId: this.bannerId,
      });
      this.bannerInfo = res.data.bannerView;
      this.bannerImageInfo = res.data.attachList;
    },

    update() {
      const params = {
        bannerId: this.bannerInfo.bannerId,
        title: this.bannerInfo.title,
        useYn: this.bannerInfo.useYn,
        linkUrl: this.bannerInfo.linkUrl,
        bannerContents: this.bannerInfo.bannerContents,
        bannerOrder: this.bannerInfo.bannerOrder,
        bannerImageInfo: this.bannerImageInfo,
      };

      this.$router.push({
        name: 'bannerupdate',
        params: { data: params },
      });
    },

    async deleteBtn() {
      let apiParams = new FormData();
      apiParams.append('bannerId', this.bannerId);
      await axios('post', '/api/admin/banner/delete.json', apiParams);
      await this.$router.push('bannerlist');
    },

    deleteConfirm() {
      this.$confirm({
        message: `삭제하시겠습니까?`,
        button: {
          no: '아니오',
          yes: '예',
        },
        callback: confirm => {
          if (confirm) {
            this.deleteBtn();
          }
        },
      });
    },
    downloadAttachFile(banner) {
			location.href = "/api/admin/banner/download.json?filePath=" + banner.filePath + "&saveNm=" + banner.saveNm + "&viewNm=" + banner.viewNm + "&fileExt=" + banner.fileExt + "&repoId=" + banner.repoId;
		},
  },
};
</script>
